const reportsData = (state = null, action) => {
  if (action.type === "SET_REPORTS_DATA") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_REPORTS_DATA": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default reportsData;
